import {IStatusPanelParams} from "ag-grid-community";
import React, {useEffect, useState} from "react";
import {Box, FormControl, IconButton, InputLabel, Select, SelectChangeEvent} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {ChevronLeft, ChevronRight, FirstPage, LastPage} from "@mui/icons-material";
import i18n from "i18next";
import {AG_GRID_LOCALE_IT} from "../../config/dictionary/agGridLocale_it";
import {AG_GRID_LOCALE_EN} from "../../config/dictionary/agGridLocale_en";
import {AG_GRID_LOCALE_FR} from "../../config/dictionary/agGridLocale_fr";
import {AG_GRID_LOCALE_ES} from "../../config/dictionary/agGridLocale_es";
import {AG_GRID_LOCALE_PT} from "../../config/dictionary/agGridLocale_pt";

interface IAgGridCustomFooterClientData {
    statusPanelParams: IStatusPanelParams;
}

const AgGridCustomFooterClientData = ({statusPanelParams}: IAgGridCustomFooterClientData) => {

    const [locale, setLocale] = useState(AG_GRID_LOCALE_EN);

    const [currentPage, setCurrentPage] = useState(0);
    const [maximumPage, setMaximumPage] = useState(0);

    const [firstRow, setFirstRow] = useState(0);
    const [lastRow, setLastRow] = useState(0);
    const [rows, setRows] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const updateValues = () => {
        setCurrentPage(statusPanelParams.api.paginationGetTotalPages() === 0 ? 0 : statusPanelParams.api.paginationGetCurrentPage() + 1);
        setMaximumPage(statusPanelParams.api.paginationGetTotalPages());

        setFirstRow(statusPanelParams.api.getLastDisplayedRow() === -1 ? 0 : statusPanelParams.api.getFirstDisplayedRow() + 1);
        setLastRow(statusPanelParams.api.getLastDisplayedRow() + 1);
        setRows(statusPanelParams.api.getModel().getRowCount());
    }

    useEffect(() => {
        statusPanelParams.api.addEventListener('firstDataRendered', (params: any) => {
            updateValues();
        });
        statusPanelParams.api.addEventListener('paginationChanged', (params: any) => {
            updateValues();
        });
    }, []);

    useEffect(() => {
        switch (i18n.resolvedLanguage) {
            case 'fr':
            case 'fr-FR':
                setLocale(AG_GRID_LOCALE_FR);
                break;
            case 'it':
            case 'it-IT':
                setLocale(AG_GRID_LOCALE_IT);
                break;
            case 'es':
            case 'es-ES':
                setLocale(AG_GRID_LOCALE_ES);
                break;
            case 'pt':
            case 'pt-PT':
                setLocale(AG_GRID_LOCALE_PT);
                break;
            case 'en':
            default:
                setLocale(AG_GRID_LOCALE_EN);
        }
    }, [i18n.resolvedLanguage]);

    return (
        <div className="ag-status-custom-bar"
             style={{display: 'flex', alignItems: 'center', gap: '3ch', padding: 0}}>
            <FormControl sx={{m: 1, minWidth: 120}} size="small" variant={'standard'}>
                <InputLabel id="ag-grid-rows-per-page">{locale.rowsPerPage}</InputLabel>
                <Select
                    labelId="ag-grid-rows-per-page"
                    id="ag-grid-rows-per-page"
                    value={rowsPerPage.toString()}
                    label={locale.rowsPerPage}
                    onChange={(event: SelectChangeEvent) => {
                        setRowsPerPage(parseInt(event.target.value));
                        statusPanelParams.api.paginationSetPageSize(Number(event.target.value))
                        statusPanelParams.api.setCacheBlockSize(Number(event.target.value))
                    }}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                </Select>
            </FormControl>
            <Box style={{display: 'flex', alignItems: 'center', gap: '1ch'}}>
                <span className="ag-status-custom-bar-value">{firstRow}</span>
                <span className="component" style={{color: 'black'}}>{locale.to}</span>
                <span className="ag-status-custom-bar-value">{lastRow}</span>
                <span className="component" style={{color: 'black'}}>{locale.of}</span>
                <span className="ag-status-custom-bar-value">{rows}</span>
            </Box>
            <Box style={{display: 'flex', alignItems: 'center', gap: '1ch'}}>
                    <span><IconButton onClick={() => statusPanelParams.api.paginationGoToFirstPage()}><FirstPage
                        sx={{fontSize: 'inherit'}}/></IconButton></span>
                <span><IconButton onClick={() => statusPanelParams.api.paginationGoToPreviousPage()}><ChevronLeft
                    sx={{fontSize: 'inherit'}}/></IconButton></span>
                <span className="component" style={{color: 'black'}}>{locale.page}</span>
                <span className="ag-status-custom-bar-value">{currentPage}</span>
                <span className="component" style={{color: 'black'}}>{locale.to}</span>
                <span className="ag-status-custom-bar-value">{maximumPage}</span>
                <span><IconButton onClick={() => statusPanelParams.api.paginationGoToNextPage()}><ChevronRight
                    sx={{fontSize: 'inherit'}}/></IconButton></span>
                <span><IconButton onClick={() => statusPanelParams.api.paginationGoToLastPage()}><LastPage
                    sx={{fontSize: 'inherit'}}/></IconButton></span>
            </Box>
        </div>
    );
};
export default AgGridCustomFooterClientData;